// extracted by mini-css-extract-plugin
export default {"delete":"DeleteModal_delete__yqNKy","action-btn":"DeleteModal_action-btn__1Ha6R"};